export default "__VITE_ASSET__DHBLNHtv__"